import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, MessageCircle } from 'lucide-react';

const LeadPopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('lead_popup_dismissed')) return;
    const timer = setTimeout(() => setShow(true), 30000);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setShow(false);
    sessionStorage.setItem('lead_popup_dismissed', '1');
  };

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      onClick={dismiss}
    >
      <div
        className="relative bg-white w-full max-w-sm shadow-2xl"
        onClick={e => e.stopPropagation()}
      >
        {/* Red top accent */}
        <div className="h-1 bg-aspire-red w-full" />

        <div className="p-6 sm:p-8">
          <button
            onClick={dismiss}
            aria-label="Close"
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>

          <span className="text-aspire-red text-xs font-bold uppercase tracking-widest">
            Limited Seats — 2026 Batch
          </span>
          <h3 className="font-heading font-extrabold text-2xl text-charcoal mt-2 mb-2 leading-tight">
            Your First Class is Completely Free
          </h3>
          <p className="text-gray-500 text-sm mb-6 leading-relaxed">
            Join hundreds of students achieving A* and A grades. No commitment needed — experience a full class before you decide.
          </p>

          <div className="flex flex-col gap-3">
            <Link
              to="/igcse"
              onClick={dismiss}
              className="btn-primary text-center"
            >
              Register Now — It's Free
            </Link>
            <a
              href="https://wa.me/94743652899"
              target="_blank"
              rel="noopener noreferrer"
              onClick={dismiss}
              className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white py-3 font-bold text-sm uppercase tracking-wide transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              Ask a Question on WhatsApp
            </a>
          </div>

          <button
            onClick={dismiss}
            className="mt-4 w-full text-center text-xs text-gray-400 hover:text-gray-500 transition-colors"
          >
            No thanks, I'll browse first
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeadPopup;
